<template>
  <v-app class="application--is-rtl main-app" app-data="true">

    <NavBar />

    <Nuxt />

    <Footer class="footer-wrap" />
    <Snackbar />
    <AlertDialog />
  </v-app>
</template>
<script>
import NavBar from '@/components/NavigationMenu/NavBar'
import Footer from '@/components/Footer/Footer'
import Snackbar from '@/components/Snackbar/Snackbar'
import AlertDialog from '@/components/Dialogs/AlertDialog/AlertDialog'



export default {
  name: 'innerPageLayout',
  components: {
    NavBar,
    Footer,
    Snackbar,
    AlertDialog,

  },
}
</script>


